import type { TranslateOptions } from 'lib/tolgee'
import TOLGEE_GLOBALS from 'utils/tolgeeGlobals'

/**
 * Datadog action names spread onto the DS dropdown slots via `slotProps`, so the
 * migrated picker keeps the analytics tracking the old in-house component had.
 */
export const DD_ACTION_NAMES = {
  trigger: 'open-custom-date-picker-range',
  preset: 'select-date-range-preset',
  apply: 'apply-custom-date-picker-range',
  cancel: 'close-custom-date-picker-range',
} as const

/** Sentinel `value` of the "All time" option — maps to a `clearsValue` DS preset. */
export const ALL_TIME_VALUE = 'all'

/** Key of the manual-range fallback option — never shown as a preset. */
export const CUSTOM_OPTION_KEY = 'custom'

/**
 * Each upload-date preset label maps to its existing Tolgee global entry so the
 * sidebar shows real translations (not the raw English label). Keyed by the
 * option's English label, which is stable across the `filterOptions` sets.
 */
export const OPTION_LABEL_TRANSLATIONS: Record<string, TranslateOptions> = {
  'All time': TOLGEE_GLOBALS.allTime,
  'Last 24 hours': TOLGEE_GLOBALS.last24hours,
  'Last 7 days': TOLGEE_GLOBALS.lastSevenDays,
  'Last 15 days': TOLGEE_GLOBALS.lastFifteenDays,
  'Last 30 days': TOLGEE_GLOBALS.lastThirtyDays,
  'Last 3 months': TOLGEE_GLOBALS['3MonthsValue'],
  'Last 6 months': TOLGEE_GLOBALS['6MonthsValue'],
  'Last 12 months': TOLGEE_GLOBALS['12MonthsValue'],
  'Last 2 years': TOLGEE_GLOBALS['24MonthsValue'],
  'Last 3 years': TOLGEE_GLOBALS['36MonthsValue'],
}
